import React from "react";
import ReactDOM from "react-dom";
import * as Users from "./api/users";
import { getSettings } from "./api/settingsApi";
import { UserProvider } from "./UserProvider";
import { Provider } from "react-redux";
import store from "./store";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import ResponsiveApp from "./ResponsiveApp";
import reportWebVitals from "./reportWebVitals";
import { firebase } from "./firebase";
import { globalSettings } from "./models/Settings";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import { AdminUser, Anonymous } from "./models/User";
import { createTheme, useRadioGroup } from "@material-ui/core";
import AccessDenied from "./views/users/AccessDenied";
import "./i18n";

const root = document.getElementById("root");

function App({ user }: { user: AdminUser }) {
  let tenantColors;
  if ("tenant" in user && user.tenant.configuration?.primaryColor) {
    tenantColors = createTheme({
      overrides: {
        MuiContainer: {
          root: {
            "@media (min-width:600px)": {
              paddingLeft: "16px",
              paddingRight: "16px"
            }
          }
        },
        MuiTypography: {
          body1: {
            fontSize: "0.85rem",
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: "0.015em"
          }
        }
      },
      palette: {
        primary: {
          main: user.tenant.configuration?.primaryColor
        }
      }
    });
  } else {
    tenantColors = createTheme({
      palette: {
        primary: {
          main: "#26449d"
        }
      }
    });
  }

  const userHasAccess = user.type !== undefined && user.type !== "ANONYMOUS";

  return (
    <UserProvider value={user}>
      <Provider store={store}>
        <ThemeProvider theme={tenantColors}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {userHasAccess ? (
              <BrowserRouter>
                <ResponsiveApp />
              </BrowserRouter>
            ) : (
              <BrowserRouter>
                <Routes>
                  <Route
                    path="/*"
                    element={<Navigate to="/access_denied" replace />}
                  />
                  <Route path="/access_denied" element={<AccessDenied />} />
                </Routes>
              </BrowserRouter>
            )}
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </Provider>
    </UserProvider>
  );
}

getSettings()
  .then(settingsResult => {
    if (settingsResult.type !== "OK")
      throw new Error("Global config has not been defined.");

    globalSettings.set(settingsResult.value);

    return Promise.all([
      firebase.init(globalSettings.settings.firebase),
      Users.self()
    ]).then(([, user]) => {
      ReactDOM.render(<App user={user} />, root);
    });
  })
  .catch(err => {
    console.error(err);

    if (err?.reason === "UNAUTHORIZED") {
      window.location.href = "/auth/logout";
      return;
    }

    ReactDOM.render(
      <div>
        An unexpected error occured. Please see console log for more details.
      </div>,
      root
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
